export const ContentsRequestStatus = {
  PENDING_ESTIMATE: {
    key: 'PENDING_ESTIMATE',
    label: '견적 대기',
  },
  PENDING_PAYMENT: {
    key: 'PENDING_PAYMENT',
    label: '결제 대기',
  },
  IN_PROGRESS: {
    key: 'IN_PROGRESS',
    label: '진행중',
  },
  COMPLETED: {
    key: 'COMPLETED',
    label: '완료',
  },
  CANCELED: {
    key: 'CANCELED',
    label: '취소',
  },
} as const;

export type ContentsRequestStatus = keyof typeof ContentsRequestStatus;

export const ContentsRequestPaymentStatus = {
  PAID: {
    key: 'PAID',
    label: '승인',
  },
  PENDING: {
    key: 'PENDING',
    label: '대기',
  },
  CANCELED: {
    key: 'CANCELED',
    label: '취소',
  },
};

export type ContentsRequestPaymentStatus =
  keyof typeof ContentsRequestPaymentStatus;
